
      fetch("/env.json")
        .then(res => res.json())
        .then(env => { window.env = env; })
        .then(() => import("/src/index.jsx"));
    